import { useLoading } from "src/hooks";
import "./loader-info.scss";

interface LoaderInfoProps {
  active?: boolean;
  children?: React.ReactNode;
  timeout?: number;
}

const LoaderInfo: React.FC<LoaderInfoProps> = ({ active = true, children, timeout = 0 }) => {
  const { isLoading } = useLoading({ isLoading: active, timeout });

  if (!isLoading) {
    return <>{children}</>;
  }

  return <div role="loader" className="loader-info" />;
};

export default LoaderInfo;
